<template>
  <!-- START: Active Shopping list -->
  <div class="d-flex flex-column mt-4">
    <!-- START: Shopping list container -->
    <div class="shopping-container mx-4 mt-1 mb-3">
      <!-- START: Shopping list heaeder view -->
      <div class="header-container d-flex flex-row align-items-center">
        <!-- Shopping list name -->
        <div class="flex-grow-1 font-size-xl font-weight-bold">{{ activeShoppingList.name }}</div>

        <!-- Shopping product added / total -->
        <div class="flex-grow-1 text-muted font-size-l">
          {{ currentSelectedProducts }} / {{ totalProducts }}
        </div>

        <!-- Close icon -->
        <div class="flex-shrink-1 text-muted font-weight-bold">
          <button class="unstyled-btn" @click="openModal()" :aria-label="$t('close')">
            <font-awesome-icon class="close-icon font-size-xl text-muted" icon="xmark" />
          </button>
        </div>
      </div>
      <!-- END: Shopping list heaeder view -->

      <!-- Rendering shopping product list -->
      <ProductView :products="activeShoppingList.items" />
    </div>
    <!-- END: Shopping list container -->
  </div>
  <!-- END: Active Shopping list -->
</template>

<script>
import ModalService from '@/modules/modals/services/modal.service';
import WCConfirmationModal from '@/components/WCConfirmationModal/WCConfirmationModal.vue';
import { MODAL_EVENTS } from '@/constants/EventConstants';
import ProductView from './ProductView.vue';

export default {
  name: 'ScanShoppingProductListOverlayView',
  props: {
    activeShoppingList: {
      type: Object,
      required: true,
    },
  },
  components: {
    ProductView,
  },
  computed: {
    /**
     * Computed - current selected product
     */
    currentSelectedProducts() {
      return (
        (this.activeShoppingList.items &&
          this.activeShoppingList.items.filter(i => i.isSelected).length) ||
        0
      );
    },

    /**
     * Total active shopping list products
     */
    totalProducts() {
      return (this.activeShoppingList.items && this.activeShoppingList.items.length) || 0;
    },
  },
  methods: {
    /**
     * Method to open modal for close shopping list confirmation
     */
    async openModal() {
      try {
        const response = await ModalService.open(WCConfirmationModal, {
          header: this.$t('closeShoppingList'),
          content: this.$t('closeShoppingListContent'),
          contentName: this.activeShoppingList.name,
          confirm: this.$t('yesClose'),
          cancel: this.$t('no'),
        });

        if (response === MODAL_EVENTS.CONFIRM) {
          this.$emit('removeShoppingList');
        }
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>
